/**
 * Checks whether the current browser tab is focused and visible.
 *
 * Uses both `document.hasFocus()` (catches overlapping windows) and
 * `document.visibilityState` (catches minimized/background tabs) for reliability.
 */
export const isTabFocused = (): boolean => {
  return document.hasFocus() && document.visibilityState === 'visible';
};
